/**
 * File for tracking route
 */
import store from '@/bootstrap/services/store';

export function analyticsRouteTrack (route: any) {
	const config: any = store.getters.get_analyticsConfig;
	const sessionID: any = store.getters.get_sessionId;

	(config || []).forEach((obj: any) => {
		const { methods } = obj;
		if (!(methods && methods.trackRoute)) { return; }

		methods.trackRoute(route, sessionID);
	});	
}